import { render, staticRenderFns } from "./TextCanvas.vue?vue&type=template&id=2a12872a&scoped=true"
import script from "./TextCanvas.vue?vue&type=script&lang=js"
export * from "./TextCanvas.vue?vue&type=script&lang=js"
import style0 from "./TextCanvas.vue?vue&type=style&index=0&id=2a12872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12872a",
  null
  
)

export default component.exports